export const TYPES = {
    INT: 'integer',
    VARCHAR : 'varchar',
    TIMESTAMP: 'timestamp'
}

export const STATISTICS_VALIDATION = {
    cid: {
        type: TYPES.INT,
        minValue: -2147483648,
        maxValue: 2147483647
    },
    mid: {
        type: TYPES.INT,
        minValue: -2147483648,
        maxValue: 2147483647
    },
    tid: {
        type: TYPES.INT,
        minValue: -2147483648,
        maxValue: 2147483647
    },
    uid: {
        type: TYPES.VARCHAR,
        maxLength: 512
    },
    sid: {
        type: TYPES.VARCHAR,
        maxLength: 512
    },
    datetime: {
        type: TYPES.TIMESTAMP
    },
    source_type: {
        type: TYPES.VARCHAR,
        maxLength: 128
    },
    source: {
        type: TYPES.VARCHAR,
        maxLength: 256
    },
    source_id: {
        type: TYPES.INT,
        minValue: -2147483648,
        maxValue: 2147483647
    },
    url: {
        type: TYPES.VARCHAR,
        maxLength: 512
    },
    event_category: {
        type: TYPES.VARCHAR,
        maxLength: 512
    },
    event: {
        type: TYPES.VARCHAR,
        maxLength: 128
    },
    target: {
        type: TYPES.VARCHAR,
        maxLength: 128
    },
    target_type: {
        type: TYPES.VARCHAR,
        maxLength: 128
    },
    target_id: {
        type: TYPES.INT,
        minValue: -2147483648,
        maxValue: 2147483647
    },
    value1: {
        type: TYPES.VARCHAR,
        maxLength: 256
    },
    value2: {
        type: TYPES.VARCHAR,
        maxLength: 256
    },
    value3: {
        type: TYPES.VARCHAR,
        maxLength: 256
    },
}
